import { render, staticRenderFns } from "./RiskEvaluateList.vue?vue&type=template&id=521a59e3&scoped=true"
import script from "./RiskEvaluateList.vue?vue&type=script&lang=js"
export * from "./RiskEvaluateList.vue?vue&type=script&lang=js"
import style0 from "./RiskEvaluateList.vue?vue&type=style&index=0&id=521a59e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521a59e3",
  null
  
)

export default component.exports